export default __webpack_public_path__ + "static/media/fullScreen1.d034ee45.svg";